import "@hotwired/turbo-rails";
import "chartkick/chart.js";

import "../javascript/controllers";
import "../javascript/channels";

import "trix";
import "@rails/actiontext";

import "../javascript/trix.js";

// Session expiration handler
document.addEventListener("turbo:before-fetch-response", (event) => {
  const response = event.detail.fetchResponse;

  if (response.statusCode === 401) {
    window.location.href = "/users/sign_in";
  }
});


// Checking if FontAwesomeKitConfig is defined, if not, we're in a fallback mode
window.addEventListener("load", () => {
  if (window.FontAwesomeKitConfig === undefined) {
    console.warn("FontAwesome config not found, enabling fallback mode for icons");
    const faIcons = document.querySelectorAll("i.fal, i.fas");
    faIcons.forEach((icon) => {
      icon.textContent = "?"
      icon.className = "fallback-icon";
    });
  }
});

// // Attempt to logout user before the page unloads
// window.addEventListener("beforeunload", (event) => {
  
//   // Determine the formData to send
//   const formData = new FormData();
//   formData.append("_method", "delete");
//   formData.append("authenticity_token", document.querySelector('meta[name="csrf-token"]').content);
  
//   // We need to use navigator.sendBeacon for logout to ensure it completes
//   navigator.sendBeacon("/users/sign_out", formData);
// })
